/*
 * @Author: yejianfei
 * @Date: 2023-04-03 10:11:24
 * @LastEditors: yejianfei
 * @LastEditTime: 2023-04-05 13:14:37
 * @Description:
 * @Developer:
 */
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { App, ConfigProvider } from 'antd';
import routers from '../router';
import '../assets/app.scss';
function WithRoutePage(props) {
    const [searchParams, setSearchParams] = useSearchParams();
    const route = {
        navigate: useNavigate(),
        params: useParams(),
        searchParams: searchParams
    };
    return React.createElement(props.page, { route: route });
}
function MyApp() {
    return (React.createElement(ConfigProvider, null,
        React.createElement(App, null,
            React.createElement(Router, null,
                React.createElement(Suspense, null,
                    React.createElement(Routes, null, routers.map((item) => {
                        var _a;
                        return (React.createElement(Route, { path: item.path, key: item.path, element: React.createElement(WithRoutePage, { page: item.component }) }, (_a = item.chidren) === null || _a === void 0 ? void 0 : _a.map((child) => React.createElement(Route, { path: child.path, key: child.path, element: React.createElement(WithRoutePage, { page: child.component }) }))));
                    })))))));
}
createRoot(document.getElementById('app')).render(React.createElement(MyApp, null));
